import React from 'react';

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { FormattedMessage } from '~/techstyle-shared/react-intl';

const SizeDescription = styled.p`
  font-weight: 600;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textEmphasized};
  margin: 0 8px;
`;

const LowCompression = styled(SizeDescription)`
  text-align: right;
`;

const filledCss = css`
  background: ${({ theme }) => theme.colors.backgroundDark};
  border-radius: 2px;
  width: 42px;
  height: 8px;
`;

const unfilledCss = css`
  background: ${({ theme }) => theme.colors.unfilledCompressionScaleBar};
  border-radius: 1px;
  width: 42px;
  height: 4px;
`;

const Bar = styled.div`
  ${({ $filled }) => ($filled ? filledCss : unfilledCss)}
  margin: 0 4px;
`;

const CompressionScaleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CompressionScale = ({ compression, className }) => {
  return (
    <CompressionScaleContainer aria-hidden className={className}>
      <LowCompression>
        <FormattedMessage
          defaultMessage="Low Compression"
          id="compression_guide.low_compression"
        />
      </LowCompression>
      <Bar $filled={Boolean(compression)} />
      <Bar $filled={compression === 'medium' || compression === 'high'} />
      <Bar $filled={compression === 'high'} />
      <SizeDescription>
        <FormattedMessage
          defaultMessage="High Compression"
          id="compression_guide.high_compression"
        />
      </SizeDescription>
    </CompressionScaleContainer>
  );
};

CompressionScale.propTypes = {
  className: PropTypes.string,
  compression: PropTypes.oneOf(['low', 'medium', 'high']).isRequired,
};

export default CompressionScale;
